import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-bp.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-bp.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { MapService } from "../../../../../map/shared/map.service";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { ViewApplicationLocationBpConstants } from "./view-application-location-bp.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { BuildingPlansService } from "../../../../../shared/services/modules/building-plans.service";
import { BehaviorSubject, debounceTime } from "rxjs";
import { EditBuildingComponent } from "./edit-building/edit-building.component";
import { AddBuildingComponent } from "./add-building/add-building.component";
import { PropertyBuildingHeadingEnumHeadingLookup } from "../../../../create-application/modules/bp/create-application-location-bp/property-building-heading.model";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { finalize, take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationLocationBpComponent = class ViewApplicationLocationBpComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    appController;
    routerParamsService;
    recipientListService;
    changeDetectorRefs;
    mapService;
    modalService;
    buildingPlansService;
    requestStatusService;
    viewApplicationService;
    active;
    propertiesForm;
    saveBtnPlaceholder = ViewApplicationLocationBpConstants.SAVE_BUTTON_PLACEHOLDER;
    descriptionLabel1 = ViewApplicationLocationBpConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationBpConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationBpConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationBpConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationLocationBpConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewApplicationLocationBpConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationBpConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationBpConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationBpConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationBpConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationBpConstants.ADDRESS_CONTROL;
    erfSizeControl = ViewApplicationLocationBpConstants.ERF_SIZE_CONTROL;
    titleDeedControl = ViewApplicationLocationBpConstants.TITLE_DEED_CONTROL;
    zoneControl = ViewApplicationLocationBpConstants.ZONE_CONTROL;
    ownerControl = ViewApplicationLocationBpConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationBpConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationBpConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationBpConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationBpConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationBpConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationBpConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = ViewApplicationLocationBpConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = ViewApplicationLocationBpConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = ViewApplicationLocationBpConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = ViewApplicationLocationBpConstants.ADD_ZONE_LABEL;
    ownerLabel = ViewApplicationLocationBpConstants.OWNER_LABEL;
    copyApplicantToOwnerZoneLabel = ViewApplicationLocationBpConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = ViewApplicationLocationBpConstants.REMOVE_PROPERTY_LABEL;
    propertyApplicationDetailsLabel = ViewApplicationLocationBpConstants.PROPERTY_APPLICATION_DETAILS_LABEL;
    buildingDetailsLabel = ViewApplicationLocationBpConstants.BUILDING_DETAILS_LABEL;
    mainBuildingLabel = ViewApplicationLocationBpConstants.MAIN_BUILDING_LABEL;
    outBuildingLabel = ViewApplicationLocationBpConstants.OUT_BUILING_LABEL;
    totalLabel = ViewApplicationLocationBpConstants.TOTAL_LABEL;
    stoepLabel = ViewApplicationLocationBpConstants.STOEP_LABEL;
    miscellaneous = ViewApplicationLocationBpConstants.MISCELLANEOUS_LABEL;
    propertyDescriptionControl = ViewApplicationLocationBpConstants.PROPERTY_DESCRIPTION_CONTROL;
    titleDeedRestrictionsControl = ViewApplicationLocationBpConstants.TITLE_DEED_RESTRICTION_CONTROL;
    externalWallsControl = ViewApplicationLocationBpConstants.EXTERNAL_WALLS_CONTROL;
    internalWallsControl = ViewApplicationLocationBpConstants.INTERNAL_WALLS_CONTROL;
    roofingControl = ViewApplicationLocationBpConstants.ROOFING_CONTROL;
    numberOfHousesUnitsControl = ViewApplicationLocationBpConstants.NUMBER_OF_HOUSES_UNITS_CONTROL;
    totalExistingControl = ViewApplicationLocationBpConstants.TOTAL_EXISTING_CONTROL;
    totalAddedControl = ViewApplicationLocationBpConstants.TOTAL_ADDED_CONTROL;
    totalFloorAreaControl = ViewApplicationLocationBpConstants.TOTAL_FLOOR_AREA_CONTROL;
    coveredExistingControl = ViewApplicationLocationBpConstants.COVERED_EXISTING_CONTROL;
    coveredAddedControl = ViewApplicationLocationBpConstants.COVERED_ADDED_CONTROL;
    openExistingControl = ViewApplicationLocationBpConstants.OPEN_EXISTING_CONTROL;
    openAddedControl = ViewApplicationLocationBpConstants.OPEN_ADDED_CONTROL;
    totalExistingPatioControl = ViewApplicationLocationBpConstants.TOTAL_EXISTING_PATIO_CONTROL;
    totalAddedPatioControl = ViewApplicationLocationBpConstants.TOTAL_ADDED_PATIO_CONTROL;
    poolControl = ViewApplicationLocationBpConstants.POOL_CONTROL;
    boundaryWallHeightControl = ViewApplicationLocationBpConstants.BOUNDARY_WALL_HEIGHT_CONTROL;
    boundaryWallRunningControl = ViewApplicationLocationBpConstants.BOUNDARY_WALL_RUNNING_CONTROL;
    coverageControl = ViewApplicationLocationBpConstants.COVERAGE_CONTROL;
    bulkCalculationControl = ViewApplicationLocationBpConstants.BULK_CALCULATION_CONTROL;
    propertyDescriptionTextPlaceHolder = ViewApplicationLocationBpConstants.PROPERTY_DESCRIPTION_LABEL;
    titleDeedRestrictionsTextPlaceHolder = ViewApplicationLocationBpConstants.TITLE_DEED_RESTRICTION_LABEL;
    externalWallsTextPlaceHolder = ViewApplicationLocationBpConstants.EXTERNAL_WALLS_LABEL;
    internalWallsTextPlaceHolder = ViewApplicationLocationBpConstants.INTERNAL_WALLS_LABEL;
    roofingTextPlaceHolder = ViewApplicationLocationBpConstants.ROOFING_LABEL;
    numberOfHousesUnitsTextPlaceHolder = ViewApplicationLocationBpConstants.NUMBER_OF_HOUSES_UNITS_LABEL;
    totalExistingPlaceHolder = ViewApplicationLocationBpConstants.TOTAL_EXISTING_LABEL;
    totalAddedTextPlaceHolder = ViewApplicationLocationBpConstants.TOTAL_ADDED_LABEL;
    totalFloorAreaTextPlaceHolder = ViewApplicationLocationBpConstants.TOTAL_FLOOR_AREA_LABEL;
    coveredExistingTextPlaceHolder = ViewApplicationLocationBpConstants.COVERED_EXISTING_LABEL;
    coveredAddedTextPlaceHolder = ViewApplicationLocationBpConstants.COVERED_ADDED_LABEL;
    openExistingTextPlaceHolder = ViewApplicationLocationBpConstants.OPEN_EXISTING_LABEL;
    openAddedTextPlaceHolder = ViewApplicationLocationBpConstants.OPEN_ADDED_LABEL;
    totalExistingPatioTextPlaceHolder = ViewApplicationLocationBpConstants.TOTAL_EXISTING_PATIO_LABEL;
    totalAddedPatioTextPlaceHolder = ViewApplicationLocationBpConstants.TOTAL_ADDED_PATIO_LABEL;
    poolTextPlaceHolder = ViewApplicationLocationBpConstants.POOL_LABEL;
    boundaryWallHeightTextPlaceHolder = ViewApplicationLocationBpConstants.BOUNDARY_WALL_HEIGHT_LABEL;
    boundaryWallRunningTextPlaceHolder = ViewApplicationLocationBpConstants.BOUNDARY_WALL_RUNNING_LABEL;
    coverageTextPlaceHolder = ViewApplicationLocationBpConstants.COVERAGE_LABEL;
    bulkCalculationTextPlaceHolder = ViewApplicationLocationBpConstants.BULK_CALCULATION_LABEL;
    calculationsLabel = ViewApplicationLocationBpConstants.CALCULATIONS_LABEL;
    resubmissionMessage = ViewApplicationLocationBpConstants.RESUBMISSION_MESSAGE;
    deleteLabel = SharedConstants.REMOVE_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    addLabel = SharedConstants.ADD_LABEL;
    removeDialogTitle = ViewApplicationLocationBpConstants.REMOVE_DIALOG_TEXT;
    removeMainContent = `${SharedConstants.REMOVE_MESSAGE} main building(s)?`;
    removeOutContent = `${SharedConstants.REMOVE_MESSAGE} outbuilding(s)?`;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneDocMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owners";
    zoneOptions = [];
    typeOptions = [];
    estimatedByOptions = [];
    externalWallsOptions = [];
    internalWallsOptions = [];
    roofingOptions = [];
    // @ts-ignore
    mainTableMapper;
    // @ts-ignore
    outTableMapper;
    mapComponent;
    modalOptions = {
        size: "lg",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
    application;
    isMapLoaded = false;
    getApplicationSetPropertiesObservableSubscription;
    selectedPropertySubscription;
    getStepMetaObservableSubscription;
    getLookupsObservableSubscription;
    allowLocationChange = true;
    constructor(aflaModuleStrategyService, route, appController, routerParamsService, recipientListService, changeDetectorRefs, mapService, modalService, buildingPlansService, requestStatusService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.modalService = modalService;
        this.buildingPlansService = buildingPlansService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.initializeColumnToObjectMapping();
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToProperty();
        this.changeDetectorRefs.detectChanges();
    }
    initializeColumnToObjectMapping() {
        this.mainTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
        this.outTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnDestroy() {
        this.routerParamsSubscription.unsubscribe();
        this.mapService.actionPropertyEnabled = false;
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    onBtnSaveClicked() {
        if (this.propertiesForm.valid) {
            const points = [];
            const properties = [];
            const propertiesArray = this.getProperties();
            propertiesArray.controls.forEach((item) => {
                const centroid = item.get("centroid").value;
                points.push(`(${centroid.x} ${centroid.y})`);
                const geometry = item.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                const owners = item.get("owners").value.recipients;
                owners.forEach((owner) => {
                    owner = RecipientUtils.removeRecipientProperties(owner);
                });
                let property = null;
                if (item.get("property") !== null && item.get("property").value !== null) {
                    property = item.get("property").value;
                    property.address = item.get("address").value;
                    property.allotment = item.get("allotment").value;
                    property.erfNumber = item.get("erfNo").value;
                    property.erfSize = item.get("erfSize").value;
                    property.farmNumber = item.get("farmNo").value;
                    property.sgCode = item.get("sgCode").value;
                    property.shape = geometryJSON;
                    property.subdivision = item.get("subdivision").value;
                    property.titleDeed = item.get("titleDeed").value;
                    property.applicationDescription = item.get("propertyDescription").value;
                    property.applicationRestrictions = item.get("titleDeedRestrictions").value;
                    property.externalWalls = item.get("externalWalls").value.value;
                    property.internalWalls = item.get("internalWalls").value.value;
                    property.roofing = item.get("roofing").value.value;
                    property.numberOfHouses = item.get("numberOfHousesUnits").value;
                    property.patioCoveredExisting = item.get("coveredExisting").value;
                    property.patioCoveredAdded = item.get("coveredAdded").value;
                    property.patioOpenExisting = item.get("openExisting").value;
                    property.patioOpenAdded = item.get("openAdded").value;
                    property.pool = item.get("pool").value;
                    property.boundaryWallHeight = item.get("boundaryWallHeight").value;
                    property.boundaryWallRunning = item.get("boundaryWallRunning").value;
                    property.coverage = item.get("coverage").value;
                    property.bulkCalculation = item.get("bulkCalculation").value;
                    property.zonings = [];
                    property.buildings = [];
                    property.owners = owners;
                }
                else {
                    property = {
                        address: item.get("address").value,
                        allotment: item.get("allotment").value,
                        erfNumber: item.get("erfNo").value,
                        erfSize: item.get("erfSize").value,
                        farmNumber: item.get("farmNo").value,
                        isDummy: false,
                        sgCode: item.get("sgCode").value,
                        shape: geometryJSON,
                        subdivision: item.get("subdivision").value,
                        titleDeed: item.get("titleDeed").value,
                        updateGeometry: false,
                        wkid: 102100,
                        applicationDescription: item.get("propertyDescription").value,
                        applicationRestrictions: item.get("titleDeedRestrictions").value,
                        externalWalls: item.get("externalWalls").value.value,
                        internalWalls: item.get("internalWalls").value.value,
                        roofing: item.get("roofing").value.value,
                        numberOfHouses: item.get("numberOfHousesUnits").value,
                        patioCoveredExisting: item.get("coveredExisting").value,
                        patioCoveredAdded: item.get("coveredAdded").value,
                        patioOpenExisting: item.get("openExisting").value,
                        patioOpenAdded: item.get("openAdded").value,
                        pool: item.get("pool").value,
                        boundaryWallHeight: item.get("boundaryWallHeight").value,
                        boundaryWallRunning: item.get("boundaryWallRunning").value,
                        coverage: item.get("coverage").value,
                        bulkCalculation: item.get("bulkCalculation").value,
                        zonings: [],
                        buildings: [],
                        owners,
                    };
                }
                // mainBuildings: new FormArray([], [Validators.min(1)]),
                const mainBuildingsArray = item.get("mainBuildings");
                mainBuildingsArray.controls.forEach((mainBuilding) => {
                    if (mainBuilding.get("id") !== null && mainBuilding.get("id").value !== null) {
                        const building = {
                            id: mainBuilding.get("id").value,
                            applicationId: mainBuilding.get("applicationId").value,
                            applicationPropertyId: mainBuilding.get("applicationPropertyId").value,
                            deleted: mainBuilding.get("deleted").value,
                            type: mainBuilding.get("type").value,
                            floor: mainBuilding.get("floor").value.toString(),
                            existingSize: mainBuilding.get("existingSize").value,
                            addedSize: mainBuilding.get("addedSize").value,
                            buildingNameNumber: mainBuilding.get("buildingNameNumber").value
                        };
                        property.buildings.push(building);
                    }
                    else {
                        const building = {
                            deleted: false,
                            type: "Main Building",
                            floor: mainBuilding.get("floor").value.toString(),
                            existingSize: mainBuilding.get("existingSize").value,
                            addedSize: mainBuilding.get("addedSize").value,
                            buildingNameNumber: mainBuilding.get("buildingNameNumber").value
                        };
                        property.buildings.push(building);
                    }
                });
                const outBuildingsArray = item.get("outBuildings");
                outBuildingsArray.controls.forEach((outBuilding) => {
                    if (outBuilding.get("id") !== null && outBuilding.get("id").value !== null) {
                        const building = {
                            id: outBuilding.get("id").value,
                            applicationId: outBuilding.get("applicationId").value,
                            applicationPropertyId: outBuilding.get("applicationPropertyId").value,
                            deleted: outBuilding.get("deleted").value,
                            type: outBuilding.get("type").value,
                            floor: outBuilding.get("floor").value.toString(),
                            existingSize: outBuilding.get("existingSize").value,
                            addedSize: outBuilding.get("addedSize").value,
                            buildingNameNumber: outBuilding.get("buildingNameNumber").value
                        };
                        property.buildings.push(building);
                    }
                    else {
                        const building = {
                            deleted: false,
                            type: "Additional Building",
                            floor: outBuilding.get("floor").value.toString(),
                            existingSize: outBuilding.get("existingSize").value,
                            addedSize: outBuilding.get("addedSize").value,
                            buildingNameNumber: outBuilding.get("buildingNameNumber").value
                        };
                        property.buildings.push(building);
                    }
                });
                const propertyZonesArray = item.get("zones");
                propertyZonesArray.controls.forEach((zoneItem) => {
                    if (zoneItem.get("id") !== null && zoneItem.get("id").value !== null) {
                        const zone = {
                            id: zoneItem.get("id").value,
                            applicationId: zoneItem.get("applicationId").value,
                            applicationPropertyId: zoneItem.get("applicationPropertyId").value,
                            deleted: false,
                            zoning: zoneItem.get("zone").value.value,
                        };
                        property.zonings.push(zone);
                    }
                    else {
                        const zone = {
                            deleted: false,
                            zoning: zoneItem.get("zone").value.value,
                        };
                        property.zonings.push(zone);
                    }
                });
                properties.push(property);
            });
            const params = {
                properties,
                applicationShape: `MULTIPOINT (${points.join(", ")})`,
                applicationWkid: 102100
            };
            this.getApplicationSetPropertiesObservableSubscription =
                this.buildingPlansService.getApplicationSetPropertiesObservable(this.application.id, params)
                    .subscribe({
                    next: () => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationBpConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveZoneClicked(propertyIndex, zoneIndex) {
        const controls = this.getZones(propertyIndex);
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked(propertyIndex) {
        const zonesControl = this.getZones(propertyIndex);
        const zoneGroup = new FormGroup({
            id: new FormControl(null),
            applicationId: new FormControl(null),
            applicationPropertyId: new FormControl(null),
            zone: new FormControl(null, [Validators.required]),
            deleted: new FormControl(null)
        });
        zonesControl.push(zoneGroup);
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.active = 0;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'PropertyRoofing' or name eq 'ApplicationType' or name eq 'PropertyEstimatedBy' or name eq 'PropertyExternalWalls' or name eq 'PropertyInternalWalls' or name eq 'Zoning')`,
        };
        this.getLookupsObservableSubscription = this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationBpConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const types = [];
        const estimatedBys = [];
        const externalWalls = [];
        const internalWalls = [];
        const roofings = [];
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PropertyRoofing") {
                    roofings.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    types.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyEstimatedBy") {
                    estimatedBys.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyExternalWalls") {
                    externalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyInternalWalls") {
                    internalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zoneOptions", zones);
        this.zoneOptions = zones;
        this.aflaModuleStrategyService.lookups.set("typeOptions", types);
        this.typeOptions = types;
        this.aflaModuleStrategyService.lookups.set("estimatedByOptions", estimatedBys);
        this.estimatedByOptions = estimatedBys;
        this.aflaModuleStrategyService.lookups.set("externalWallsOptions", externalWalls);
        this.externalWallsOptions = externalWalls;
        this.aflaModuleStrategyService.lookups.set("internalWallsOptions", internalWalls);
        this.internalWallsOptions = internalWalls;
        this.aflaModuleStrategyService.lookups.set("roofingOptions", roofings);
        this.roofingOptions = roofings;
        this.getApplicantData();
        this.changeDetectorRefs.detectChanges();
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.ownerGroups = stepMeta.ownerGroup;
            if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
            }
            this.getLookups();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `properties($expand=buildings,zonings,owners($expand=groups))`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnValue) => {
            this.allowLocationChange = !returnValue.value[0].isResubmission;
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.application = returnValue.value[0];
            const geometries = [];
            this.application.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                geometries.push(geom);
                let externalWalls = null;
                this.externalWallsOptions.forEach(item => {
                    if (item.value === property.externalWalls) {
                        externalWalls = item;
                    }
                });
                let internalWalls = null;
                this.internalWallsOptions.forEach(item => {
                    if (item.value === property.internalWalls) {
                        internalWalls = item;
                    }
                });
                let roofing = null;
                this.roofingOptions.forEach(item => {
                    if (item.value === property.roofing) {
                        roofing = item;
                    }
                });
                const newProperty = new FormGroup({
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber, [Validators.required]),
                    subdivision: new FormControl(property.subdivision, [Validators.required]),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    erfSize: new FormControl(property.erfSize, [Validators.required]),
                    titleDeed: new FormControl(property.titleDeed, [Validators.required]),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    zones: new FormArray([], [Validators.min(1)]),
                    owners: new FormControl({ recipients: [] }, [Validators.required]),
                    propertyDescription: new FormControl(property.applicationDescription, [Validators.required]),
                    titleDeedRestrictions: new FormControl(property.applicationRestrictions, [Validators.required]),
                    externalWalls: new FormControl(externalWalls, [Validators.required]),
                    internalWalls: new FormControl(internalWalls, [Validators.required]),
                    roofing: new FormControl(roofing, [Validators.required]),
                    numberOfHousesUnits: new FormControl(property.numberOfHouses, [Validators.required]),
                    totalExisting: new FormControl({ value: 0, disabled: true }),
                    totalAdded: new FormControl({ value: 0, disabled: true }),
                    totalFloorArea: new FormControl({ value: 0, disabled: true }),
                    coveredExisting: new FormControl(property.patioCoveredExisting, [Validators.required]),
                    coveredAdded: new FormControl(property.patioCoveredAdded, [Validators.required]),
                    openExisting: new FormControl(property.patioOpenExisting, [Validators.required]),
                    openAdded: new FormControl(property.patioOpenAdded, [Validators.required]),
                    totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                    totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                    pool: new FormControl(property.pool, [Validators.required]),
                    boundaryWallHeight: new FormControl(property.boundaryWallHeight, [Validators.required]),
                    boundaryWallRunning: new FormControl(property.boundaryWallRunning, [Validators.required]),
                    coverage: new FormControl({ value: property.coverage, disabled: true }),
                    bulkCalculation: new FormControl({ value: property.bulkCalculation, disabled: true }),
                    mainBuildings: new FormArray([]),
                    outBuildings: new FormArray([]),
                    mainTableDataSource: new FormControl(new BehaviorSubject([])),
                    mainTableSelection: new FormControl([]),
                    outTableDataSource: new FormControl(new BehaviorSubject([])),
                    outTableSelection: new FormControl([]),
                });
                if (!this.allowLocationChange) {
                    newProperty.controls.erfNo.disable();
                    newProperty.controls.farmNo.disable();
                    newProperty.controls.subdivision.disable();
                    newProperty.controls.allotment.disable();
                }
                const mainTableDataSource = newProperty.get("mainTableDataSource").value;
                const outTableDataSource = newProperty.get("outTableDataSource").value;
                const mainItems = [];
                const outItems = [];
                property.buildings.forEach(building => {
                    if (building.type === "Main Building") {
                        mainItems.push(building);
                    }
                    else {
                        outItems.push(building);
                    }
                });
                mainTableDataSource.next(mainItems);
                outTableDataSource.next(outItems);
                const zonesControl = newProperty.get("zones");
                property.zonings.forEach(zone => {
                    this.zoneOptions.forEach(zoneOption => {
                        if (zoneOption.value === zone.zoning) {
                            const zoneGroup = new FormGroup({
                                id: new FormControl(zone.id),
                                applicationId: new FormControl(zone.applicationId),
                                applicationPropertyId: new FormControl(zone.applicationPropertyId),
                                zone: new FormControl(zoneOption, [Validators.required]),
                                deleted: new FormControl(zone.deleted)
                            });
                            zonesControl.push(zoneGroup);
                        }
                    });
                });
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                const getTrueCentroid = this.viewApplicationService.getTrueCentroid(url, formData).pipe(takeUntil(this._destroy$), take(1)).pipe(finalize(() => {
                    getTrueCentroid.unsubscribe();
                })).subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        const ownersControl = newProperty.get("owners");
                        this.recipientListService.setRecipients(property.owners, false, ownersControl);
                        this.updateRequiredFields(propertyControl.length - 1);
                        this.changeDetectorRefs.detectChanges();
                        this.syncMainBuildings();
                        this.syncOutBuildings();
                        this.calculateTotals();
                        this.changeDetectorRefs.detectChanges();
                        if (this.isMapLoaded) {
                            this.syncMapGeometries();
                        }
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationBpConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            });
            if (this.isMapLoaded === true) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    subscribeToProperty() {
        if (this.allowLocationChange === false) {
            this.appController.showMessage(this.resubmissionMessage, AlertType.Warning);
            return;
        }
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        if (this.allowLocationChange === false) {
            this.appController.showMessage(this.resubmissionMessage, AlertType.Warning);
            return;
        }
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Business licence graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(ViewApplicationLocationBpConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfNumber"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnNum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmNumber"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                erfSize: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfSize", "erfSize"), [Validators.required]),
                titleDeed: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed"), [Validators.required]),
                propertyDescription: new FormControl(null, [Validators.required]),
                titleDeedRestrictions: new FormControl(null, [Validators.required]),
                externalWalls: new FormControl(null, [Validators.required]),
                internalWalls: new FormControl(null, [Validators.required]),
                roofing: new FormControl(null, [Validators.required]),
                numberOfHousesUnits: new FormControl(null, [Validators.required]),
                totalExisting: new FormControl({ value: 0, disabled: true }),
                totalAdded: new FormControl({ value: 0, disabled: true }),
                totalFloorArea: new FormControl({ value: 0, disabled: true }),
                coveredExisting: new FormControl(0, [Validators.required]),
                coveredAdded: new FormControl(0, [Validators.required]),
                openExisting: new FormControl(0, [Validators.required]),
                openAdded: new FormControl(0, [Validators.required]),
                totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                pool: new FormControl(0, [Validators.required]),
                boundaryWallHeight: new FormControl(0, [Validators.required]),
                boundaryWallRunning: new FormControl(0, [Validators.required]),
                coverage: new FormControl({ value: 0, disabled: true }),
                bulkCalculation: new FormControl({ value: 0, disabled: true }),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required]),
                mainBuildings: new FormArray([]),
                outBuildings: new FormArray([]),
                mainTableDataSource: new FormControl(new BehaviorSubject([])),
                mainTableSelection: new FormControl([]),
                outTableDataSource: new FormControl(new BehaviorSubject([])),
                outTableSelection: new FormControl([]),
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            const getTrueCentroid = this.viewApplicationService.getTrueCentroid(url, formData).pipe(takeUntil(this._destroy$), take(1)).pipe(finalize(() => {
                getTrueCentroid.unsubscribe();
            }))
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property zone");
                    if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
                        const zoningLayer = zoningLayerObj.layer;
                        const zoningQuery = new Query();
                        zoningQuery.where = `SgCode = '${sgCode}'`;
                        zoningQuery.returnGeometry = false;
                        zoningQuery.outFields = ["*"];
                        zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                            // Make sure the grave centroid is within one cemetery boundary
                            const zonesControl = newProperty.get("zones");
                            if (zoneFeatureSet.features.length > 0) {
                                zoneFeatureSet.features.forEach(item => {
                                    const zone = this.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                                    if (zone !== undefined && zone != null) {
                                        let foundZone = null;
                                        this.zoneOptions.forEach(zoneItem => {
                                            if (zoneItem.value === zone) {
                                                foundZone = zoneItem;
                                            }
                                        });
                                        if (zonesControl.length === 0) {
                                            zonesControl.push(new FormGroup({
                                                zone: new FormControl(foundZone, [Validators.required])
                                            }));
                                        }
                                        else {
                                            this.appController.showMessage(ViewApplicationLocationBpConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Error);
                                            const params = {
                                                moduleId: this.moduleID, lookupType: "Zoning", lookupList: [zone]
                                            };
                                            this.viewApplicationService.sendMissingLookupsEmail(params).subscribe();
                                        }
                                    }
                                    else {
                                        this.appController.showMessage(ViewApplicationLocationBpConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                                    }
                                });
                            }
                            if (zonesControl.length === 0) {
                                zonesControl.push(new FormGroup({
                                    zone: new FormControl(null, [Validators.required])
                                }));
                            }
                            this.getPropertyOwners(sgCode, newProperty);
                        }, (zoningError) => {
                            this.appController.showMessage(zoningError.message, AlertType.Error);
                            this.getPropertyOwners(sgCode, newProperty);
                        });
                    }
                    else {
                        this.getPropertyOwners(sgCode, newProperty);
                    }
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(ViewApplicationLocationBpConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(ViewApplicationLocationBpConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                this.recipientListService.setRecipients(owners, false, ownersControl);
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Building plans graphics", true);
        }
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveMainClicked(propertyIndex) {
        let mainTableSelection = this.getProperties().controls[propertyIndex].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties().controls[propertyIndex].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const deletedItem = mainTableSelection;
        let index = 0;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === deletedItem) {
                index = i;
            }
        }
        const options = {
            size: "sm",
            centered: true,
            keyboard: false,
            backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeMainContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = index;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex !== undefined && deletedIndex !== null) {
                itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                this.getProperties().controls[propertyIndex].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch(() => {
        });
    }
    onBtnEditMainClicked(propertyIndex) {
        let mainTableSelection = this.getProperties().controls[propertyIndex].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties().controls[propertyIndex].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (mainTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === mainTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit main building";
        modalRef.componentInstance.building = mainTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedbuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedbuilding) {
                itemsAlreadyOnTable[updatedbuilding[0]] = updatedbuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                this.getProperties().controls[propertyIndex].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch(() => {
        });
    }
    onBtnAddMainClicked(propertyIndex) {
        let mainTableSelection = this.getProperties().controls[propertyIndex].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties().controls[propertyIndex].get("mainTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add main building";
        modalRef.componentInstance.type = "Main Building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = mainTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                this.getProperties().controls[propertyIndex].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch(() => {
        });
    }
    onBtnRemoveOutClicked(propertyIndex) {
        let outTableSelection = this.getProperties().controls[propertyIndex].get("outTableSelection").value;
        const outTableDataSource = this.getProperties().controls[propertyIndex].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const deletedItem = outTableSelection;
        let index = 0;
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === deletedItem) {
                index = i;
            }
        }
        const options = {
            size: "sm",
            centered: true,
            keyboard: false,
            backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeOutContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = index;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex !== undefined && deletedIndex !== null) {
                itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                this.getProperties().controls[propertyIndex].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch(() => {
        });
    }
    onBtnEditOutClicked(propertyIndex) {
        let outTableSelection = this.getProperties().controls[propertyIndex].get("outTableSelection").value;
        const outTableDataSource = this.getProperties().controls[propertyIndex].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (outTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === outTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit outbuilding";
        modalRef.componentInstance.building = outTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedbuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedbuilding) {
                itemsAlreadyOnTable[updatedbuilding[0]] = updatedbuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                this.getProperties().controls[propertyIndex].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch(() => {
        });
    }
    onBtnAddOutClicked(propertyIndex) {
        let outTableSelection = this.getProperties().controls[propertyIndex].get("outTableSelection").value;
        const outTableDataSource = this.getProperties().controls[propertyIndex].get("outTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add outbuilding";
        modalRef.componentInstance.type = "Additional building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = outTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                this.getProperties().controls[propertyIndex].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch(() => {
        });
    }
    mainArrayReturned(array, index) {
        this.getProperties().controls[index].get("mainTableSelection").setValue(array);
    }
    outArrayReturned(array, index) {
        this.getProperties().controls[index].get("outTableSelection").setValue(array);
    }
    syncMainBuildings() {
        this.getProperties().controls.forEach(property => {
            const items = property.get("mainTableDataSource").value.getValue();
            const formItems = property.get("mainBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    id: new FormControl(item.id),
                    applicationId: new FormControl(item.applicationId),
                    applicationPropertyId: new FormControl(item.applicationPropertyId),
                    deleted: new FormControl(item.deleted),
                    type: new FormControl(item.type),
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize),
                    buildingNameNumber: new FormControl(item.buildingNameNumber)
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    syncOutBuildings() {
        this.getProperties().controls.forEach(property => {
            const items = property.get("outTableDataSource").value.getValue();
            const formItems = property.get("outBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    id: new FormControl(item.id),
                    applicationId: new FormControl(item.applicationId),
                    applicationPropertyId: new FormControl(item.applicationPropertyId),
                    deleted: new FormControl(item.deleted),
                    type: new FormControl(item.type),
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize),
                    buildingNameNumber: new FormControl(item.buildingNameNumber)
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    calculateTotals() {
        const properties = this.getProperties().controls;
        properties.forEach(property => {
            property.get("coverage").setValue(0);
            property.get("bulkCalculation").setValue(0);
            let totalExistingPatioCalculated = 0.00;
            let totalAddedPatioCalculated = 0.00;
            let totalExistingCalculated = 0.00;
            let totalAddedCalculated = 0.00;
            let totalFloorCalculated = 0.00;
            let totalGroundFloorCalculated = 0.00;
            try {
                if (property.get("coveredExisting").value !== null && property.get("coveredAdded").value !== null &&
                    property.get("openExisting").value !== null && property.get("openAdded").value !== null) {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const patioOpenExisting = property.get("openExisting").value;
                    const patioOpenAdded = property.get("openAdded").value;
                    totalExistingPatioCalculated += patioCoverageExisting + patioOpenExisting;
                    totalAddedPatioCalculated += patioCoverageAdded + patioOpenAdded;
                    property.get("totalExistingPatio").setValue(totalExistingPatioCalculated);
                    property.get("totalAddedPatio").setValue(totalAddedPatioCalculated);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                const mainBuildings = property.get("mainBuildings");
                const outbuildings = property.get("outBuildings");
                mainBuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value.toString() === "0") {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                outbuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value.toString() === "0") {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                totalFloorCalculated = totalAddedCalculated + totalExistingCalculated;
                property.get("totalExisting").setValue(totalExistingCalculated);
                property.get("totalAdded").setValue(totalAddedCalculated);
                property.get("totalFloorArea").setValue(totalFloorCalculated);
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                if (property.get("coveredExisting").value !== null && property.get("coveredAdded").value !== null && property.get("erfSize").value !== null) {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const totalCoveredPatio = 0.00 + patioCoverageExisting + patioCoverageAdded;
                    const totalCoveredArea = 0.00 + totalExistingCalculated + totalAddedCalculated + totalCoveredPatio;
                    const totalFloorArea = 0.00 + totalGroundFloorCalculated + totalCoveredPatio;
                    const totalArea = 0.00 + property.get("erfSize").value;
                    const bulkCalculation = totalCoveredArea / totalArea;
                    const covered = totalFloorArea / totalArea * 100;
                    property.get("coverage").setValue(Math.round(covered * 100) / 100);
                    property.get("bulkCalculation").setValue(Math.round(bulkCalculation * 100) / 100);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
        });
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: NgbModal },
        { type: BuildingPlansService },
        { type: RequestStatusService },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationBpComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-location-bp",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationBpComponent);
export { ViewApplicationLocationBpComponent };
